import { DocumentNode } from 'graphql';
import { useTranslation } from 'react-i18next';

import { Registration } from '../helpers';
import { useNotifier } from '../../../common/Notifications/NotificationProvider';
import GetRegistrationSummaryForDashboardQuery from './GetRegistrationSummaryForDashboardQuery';
import ResumeWaitlistMutation from './ResumeWaitlistMutation';
import UI from '../../../common/UI';
import useMutation from '../../../api/useMutation';

export interface ResumeWaitlistFormProps {
  registration: Registration;
  refetchQueries?: DocumentNode[];
}

const ResumeWaitlistForm = ({
  registration,
  refetchQueries = [GetRegistrationSummaryForDashboardQuery],
}: ResumeWaitlistFormProps) => {
  const { t } = useTranslation();
  const notifier = useNotifier();

  const [resumeWaitlist, { error, loading }] = useMutation(
    ResumeWaitlistMutation,
    {
      variables: {
        input: {
          registration: { id: registration.id },
        },
      },
      onCompleted: () => {
        notifier.success(t('information_saved'));
      },
      onError: () => {
        notifier.error(t('something_went_wrong'));
      },
      refetchQueries,
    },
  );

  return (
    <UI.FormGrid sc={{ padding: [3, 4] }}>
      {!registration.waitlist_paused && (
        <UI.Success>
          {t('resume_waitlist_resumed_message')}
        </UI.Success>
      )}
      {registration.waitlist_paused && (
        <UI.Form onSubmit={() => resumeWaitlist()}>
          <UI.FormGrid>
            <UI.ServerErrors error={error} />

            <UI.Div>
              {t('resume_waitlist_description')}
            </UI.Div>

            <UI.Button
              type="submit"
              sc={{ brand: 'secondary', loading }}
              disabled={loading}
            >
              {t('resume')}
            </UI.Button>
          </UI.FormGrid>
        </UI.Form>
      )}
    </UI.FormGrid>
  );
};

export default ResumeWaitlistForm;
